import {
  Input as ChakraInput,
  FormLabel,
  FormControl,
  InputProps as ChakraInputProps,
  FormErrorMessage,
} from '@chakra-ui/react'
import { forwardRef, ForwardRefRenderFunction } from 'react'
import { FieldError } from 'react-hook-form'

interface InputProps extends ChakraInputProps {
  name: string
  label?: string
  mask?: string
  colorLabel?: string
  error?: FieldError
}

const InputBase: ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
  { name, label, mask, error = undefined, colorLabel = '#002147', ...rest },
  ref,
) => {
  return (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel htmlFor={name} color={colorLabel}>
          {label}
        </FormLabel>
      )}
      <ChakraInput
        id={name}
        name={name}
        mask={mask}
        variant="filled"
        size="lg"
        borderRadius="12"
        borderColor="gray.700"
        color={colorLabel}
        _hover={{
          borderColor: colorLabel,
        }}
        _focus={{
          borderColor: colorLabel,
        }}
        ref={ref}
        {...rest}
      />

      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  )
}

export const Input = forwardRef(InputBase)
